import {
  CONTENT_NODE_SUGGESTION_TYPES,
  PAGE_SUGGESTION_TYPES,
} from '../constants/content-suggestion';

export function getContentNodeSuggestions(contentSuggestions, component) {
  return contentSuggestions.filter((suggestion) => {
    const { contentNode: targetContentNodeId, type } = suggestion;
    const { contentNodes = [] } = component;

    const isContentNodeType = CONTENT_NODE_SUGGESTION_TYPES.includes(type);

    return contentNodes.some((node) => node.id === targetContentNodeId) && isContentNodeType;
  });
}

export function getPageContentSuggestions(contentSuggestions, page, fieldType = null) {
  const { id: pageId } = page;

  return contentSuggestions.filter((suggestion) => {
    const { page: tagetPageId, type } = suggestion;

    const isPageType = PAGE_SUGGESTION_TYPES.includes(type);

    if (fieldType) {
      return isPageType && tagetPageId === pageId && type === fieldType;
    }

    return isPageType && tagetPageId === pageId;
  });
}
